import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './UserLogin.css';

function UserLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  // Dummy credentials
  const DUMMY_EMAIL = 'admin@example.com';
  const DUMMY_PASSWORD = 'admin123';

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');

    // Check dummy credentials
    if ((email === DUMMY_EMAIL && password === DUMMY_PASSWORD) || (email === 'seeds@fincap.com' && password === 'Seedsadmin@123')) {
      // Store authentication token in sessionStorage
      const authData = {
        isAuthenticated: true,
        user: {
          email: email,
          roleMaster: {
            role_name: 'SUPERADMIN',
          },
        },
        token: 'dummy-auth-token-12345',
      };

      sessionStorage.setItem('authToken', authData.token);
      sessionStorage.setItem('tokens', JSON.stringify({ token: authData.token }));
      sessionStorage.setItem('isAuthenticated', JSON.stringify(true));
      sessionStorage.setItem('officer', JSON.stringify(authData.user));
      localStorage.setItem('sidebar_expanded', 'false');

      // Navigate to user management
      navigate('/user-management');
    } else {
      setError('Invalid email or password');
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <h2 className="login-title">Login</h2>
        <form onSubmit={handleLogin}>
          <div className="input-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="login-input"
              required
            />
          </div>
          <div className="input-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="login-input"
              required
            />
          </div>
          {error && <p className="error-message">{error}</p>}
          <button type="submit" className="login-button">
            Login
          </button>
          <p style={{ marginTop: '1rem', fontSize: '0.9rem', color: '#666' }}>
            admin@example.com / admin123
          </p>
        </form>
      </div>
    </div>
  );
}

export default UserLogin;
